import gql from 'graphql-tag';

/**
 * @param {String} fieldUUID
 * @param {String} cropId
 * @param {String} seasonTag
 * @param {String} passName
 * @param {String} applicationDate
 * @param {String} applicationUnits units of volume / area for application buckets
 * @param {Array} applicationBuckets array of application bucket values from legends
 * @param {Boolean} includeApplication
 * @param {Object} geometry
 * @returns {Object} FRR Application Events
 */
export function getFieldRegionReportApplicationEvents({
  fieldUUID,
  cropId,
  seasonTag,
  passName,
  applicationDate,
  applicationUnits,
  applicationBuckets,
  geometry,
  includeApplication
  }) {

  return {
    query: gql`
    query fieldRegionReportApplicationEvents(
      $fieldUUID: String!, 
      $cropId: String!, 
      $seasonTag: String!, 
      $geometry: GeometryInput!, 
      $passName: String!, 
      $applicationDate: String!, 
      $applicationUnits: String!, 
      $applicationBuckets: [Float]!,
      $includeApplication: Boolean!
    ) {
      reports {
        fieldRegionReportApplicationEvents(
          fieldUUID: $fieldUUID,
          cropId: $cropId,
          seasonTag: $seasonTag,
          passName: $passName,
          applicationDate: $applicationDate,
          applicationUnits: $applicationUnits,
          applicationBuckets: $applicationBuckets,
          geometry: $geometry,
          includeApplication: $includeApplication
        ){
            applicationUnits,
            appliedApplicationRateYield {
              averageYield {
                q
                u
              }
              averageMoisture {
                q
                u
              }
              area {
                q
                u
              }
              range {
                min
                max
              }
            }
            unAppliedApplicationRateYield {
              averageYield {
                q
                u
              }
              averageMoisture {
                q
                u
              }
              area {
                q
                u
              }
              range {
                min
                max
              }
            }
          } 
      }
    }`,
    variables: {
      fieldUUID,
      cropId,
      seasonTag,
      passName,
      applicationDate,
      applicationUnits,
      applicationBuckets,
      geometry,
      includeApplication
    },
  };
}
